module.exports = __webpack_public_path__ + "confeti.png";